export default "__VITE_ASSET__42ff22aa__"